import { render, staticRenderFns } from "./editVipIcon.vue?vue&type=template&id=c1cac384&scoped=true&lang=pug"
import script from "./editVipIcon.vue?vue&type=script&lang=js"
export * from "./editVipIcon.vue?vue&type=script&lang=js"
import style0 from "./editVipIcon.vue?vue&type=style&index=0&id=c1cac384&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1cac384",
  null
  
)

export default component.exports